module.exports = __webpack_public_path__ + "img/sponsorT25.68224dfb.png";